import { findMessage } from '@bimser/components';
import { FormItemTypes, HorizontalAlign, IDictionary } from '@bimser/core';
import { JSX } from 'react';
import {
	CovertFontToCSS,
	HeadingType,
	ICSSProperties,
	IPropertyField
} from '../../../../entities/common';
import LabelBase from '../../base/LabelBase';
import Styles from './assets/styles.scss';
import { IHeaderProperties } from './entities/IHeaderProperties';

export default class Header extends LabelBase {
	headingType: HeadingType;
	textAlign: HorizontalAlign;

	constructor() {
		super();
		this.controlType = FormItemTypes.EControlTypes.Header;
		this.font.color = '#555';
		this.font.size = null;
		this.headingType = 'h3';
		this.textAlign = 'left';
	}

	initialize() {
		super.initialize();
		this.text.setData({ [this.__form.currentLanguage.culture]: findMessage.get('100029') });
	}

	__loadProperties(data: IHeaderProperties) {
		super.__loadProperties(data);

		this.__proxyChanged.headingType = data.headingType;
		this.__proxyChanged.textAlign = data.textAlign;
	}

	private getStyles(): ICSSProperties {
		return CovertFontToCSS(this.font);
	}

	__getPropertyFields(): IPropertyField[] {
		return [
			...super.__getPropertyFields(),
			{
				name: 'headingType',
				type: 'enum',
				enumMembers: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as HeadingType[]
			},
			{
				name: 'textAlign',
				type: 'enum',
				enumMembers: ['left', 'center', 'right']
			}
		];
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			headingType: this.headingType,
			textAlign: this.textAlign
		};
	}

	__render(children?: JSX.Element) {
		const TagName = this.headingType;
		const style: React.CSSProperties = {
			...this.getStyles(),
			...this.style,
			textAlign: this.textAlign,
			height: this.height,
			lineHeight: this.lineHeight
		};

		return super.__render(
			<TagName
				style={style}
				className={`${Styles.HeaderFitContent} ${Styles[TagName]}`}
				title={this.title.getText()}
			>
				{this.text.getText()}
			</TagName>
		);
	}
}
